export const scheduleTranslations = {
  fr: {
    emptyTitle: "Aucune révision programmée",
    emptyDescription: "Créez des flashcards pour commencer votre planning de révision personnalisé.",
    emptyStart: "Commencez maintenant :",
    useGenerate: "Utilisez le générateur IA pour créer du contenu",
    useCollaboration: "Explorez les decks collaboratifs",
    today: "Aujourd'hui",
    overdue: "en retard",
    estimatedTime: "Temps estimé",
    thisWeek: "Cette semaine",
    avgDifficulty: "Difficulté moyenne",
    workloadTitle: "Charge de travail",
    workload: {
      light: "Légère",
      lightShort: "Légère",
      moderate: "Modérée", 
      moderateShort: "Mod.",
      intense: "Intensive",
      intenseShort: "Int."
    },
    tabs: {
      today: "Aujourd'hui",
      week: "Semaine",
      month: "Mois"
    },
    todayView: {
      title: "Cartes à réviser aujourd'hui",
      startSession: "Démarrer la session",
      priority: "Priorité",
      daysOverdue: "jours de retard",
      noDueCards: "Aucune carte due aujourd'hui !",
      comeBackTomorrow: "Revenez demain pour de nouvelles révisions."
    },
    weekView: {
      title: "Planning de la semaine"
    },
    monthView: {
      title: "Vue mensuelle"
    },
    easeLabel: "Facilité",
    intervalLabel: "Intervalle",
    mastery: {
      notEvaluated: "Non évalué",
      mastered: "Maîtrisé",
      learning: "En apprentissage",
      toLearn: "À apprendre"
    },
    errors: {
      loadError: "Erreur lors du chargement du planning"
    }
  },
  en: {
    emptyTitle: "No scheduled reviews",
    emptyDescription: "Create flashcards to start your personalized review schedule.",
    emptyStart: "Start now:",
    useGenerate: "Use AI generator to create content",
    useCollaboration: "Explore collaborative decks",
    today: "Today",
    overdue: "overdue",
    estimatedTime: "Estimated time",
    thisWeek: "This week",
    avgDifficulty: "Average difficulty",
    workloadTitle: "Workload",
    workload: {
      light: "Light",
      lightShort: "Light",
      moderate: "Moderate", 
      moderateShort: "Mod.",
      intense: "Intensive",
      intenseShort: "Int."
    },
    tabs: {
      today: "Today",
      week: "Week",
      month: "Month"
    },
    todayView: {
      title: "Cards to review today",
      startSession: "Start session",
      priority: "Priority",
      daysOverdue: "days overdue",
      noDueCards: "No cards due today!",
      comeBackTomorrow: "Come back tomorrow for new reviews."
    },
    weekView: {
      title: "Week schedule"
    },
    monthView: {
      title: "Monthly view"
    },
    easeLabel: "Ease",
    intervalLabel: "Interval",
    mastery: {
      notEvaluated: "Not evaluated",
      mastered: "Mastered",
      learning: "Learning",
      toLearn: "To learn"
    },
    errors: {
      loadError: "Error loading schedule"
    }
  },
  es: {
    emptyTitle: "No hay repasos programados",
    emptyDescription: "Crea tarjetas de estudio para comenzar tu horario de repaso personalizado.",
    emptyStart: "Comienza ahora:",
    useGenerate: "Usa el generador IA para crear contenido",
    useCollaboration: "Explora mazos colaborativos",
    today: "Hoy",
    overdue: "atrasado",
    estimatedTime: "Tiempo estimado",
    thisWeek: "Esta semana",
    avgDifficulty: "Dificultad promedio",
    workloadTitle: "Carga de trabajo",
    workload: {
      light: "Ligera",
      lightShort: "Ligera",
      moderate: "Moderada", 
      moderateShort: "Mod.",
      intense: "Intensiva",
      intenseShort: "Int."
    },
    tabs: {
      today: "Hoy",
      week: "Semana",
      month: "Mes"
    },
    todayView: {
      title: "Tarjetas para repasar hoy",
      startSession: "Iniciar sesión",
      priority: "Prioridad",
      daysOverdue: "días de retraso",
      noDueCards: "¡No hay tarjetas pendientes hoy!",
      comeBackTomorrow: "Vuelve mañana para nuevos repasos."
    },
    weekView: {
      title: "Horario de la semana"
    },
    monthView: {
      title: "Vista mensual"
    },
    easeLabel: "Facilidad",
    intervalLabel: "Intervalo",
    mastery: {
      notEvaluated: "No evaluado",
      mastered: "Dominado",
      learning: "Aprendiendo",
      toLearn: "Por aprender"
    },
    errors: {
      loadError: "Error cargando horario"
    }
  }
};